import styled from 'styled-components';

export const StepContainer = styled.div`
  padding: 0;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  border-radius: 8px;
  min-height: 600px;
  overflow-x: hidden;
  position: relative;

  .pages-title {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`;

export const StepBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: ${(props: any) => props.theme.colors.primaryRed400};
  color: ${(props: any) => props.theme.colors.pureWhite};
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionContainer = styled.div`
  /* Container para cada seção do formulário */
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

export const BackButton = styled.button`
  padding: 12px 24px;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.c718096};
  border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cf7fafc};
    border-color: ${(props: any) => props.theme.colors.ccbd5e0};
  }

  &:active {
    transform: translateY(1px);
  }
`;

export const NextButton = styled.button`
  padding: 12px 24px;
  background-color: ${(props: any) => props.theme.colors.primaryRed400};
  color: ${(props: any) => props.theme.colors.pureWhite};
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cd41e35};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(229, 41, 64, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(229, 41, 64, 0.3);
  }

  &:disabled {
    background-color: ${(props: any) => props.theme.colors.ccbd5e0};
    cursor: not-allowed;
    transform: none;
    box-shadow: none;

    &:hover {
      background-color: ${(props: any) => props.theme.colors.ccbd5e0};
      transform: none;
      box-shadow: none;
    }
  }
`;
